import { exec } from 'child_process'
import { ErrorCode, Defaults } from '@remotekit/shared'
import { RemoteKitError } from '@remotekit/shared'
import type { CommandHandlerFn } from '../command-handler'

export interface ShellHandlerOptions {
  enabled: boolean
  whitelist: string[]
}

const DANGEROUS_PATTERNS = [
  /^rm\s+(-[a-z]*\s+)*-[a-z]*r[a-z]*f[a-z]*\s+\//,
  /^rm\s+(-[a-z]*\s+)*-[a-z]*f[a-z]*r[a-z]*\s+\//,
  /^mkfs/,
  /^dd\s/,
  /^shutdown/,
  /^reboot/,
  /^init\s+[06]/,
  /^:(){ :\|:& };:/,
]

export function createShellHandlers(options: ShellHandlerOptions): Record<string, CommandHandlerFn> {
  return {
    'shell:exec': async (params?: { command: string; cwd?: string; timeout?: number }) => {
      if (!options.enabled) {
        throw new RemoteKitError(ErrorCode.SHELL_DISABLED, 'shell:exec 未启用')
      }

      if (!params?.command) {
        throw new RemoteKitError(ErrorCode.SHELL_BLOCKED, '缺少 command 参数')
      }

      const command = params.command.trim()

      // 黑名单检查
      for (const pattern of DANGEROUS_PATTERNS) {
        if (pattern.test(command)) {
          throw new RemoteKitError(ErrorCode.SHELL_BLOCKED, `危险命令被拒绝: ${command}`)
        }
      }

      // 白名单检查
      if (options.whitelist.length > 0) {
        const allowed = options.whitelist.some((prefix) => command.startsWith(prefix))
        if (!allowed) {
          throw new RemoteKitError(ErrorCode.SHELL_BLOCKED, `命令不在白名单内: ${command}`)
        }
      }

      const timeout = Math.min(
        params.timeout || Defaults.SHELL_TIMEOUT,
        Defaults.SHELL_MAX_TIMEOUT,
      )

      return new Promise((resolve) => {
        exec(command, {
          cwd: params.cwd,
          timeout,
          maxBuffer: Defaults.SHELL_OUTPUT_MAX_SIZE,
        }, (error, stdout, stderr) => {
          let exitCode = 0
          if (error) {
            exitCode = typeof error.code === 'number' ? error.code : (error as any).killed ? 137 : 1
          }
          resolve({
            stdout: stdout.slice(0, Defaults.SHELL_OUTPUT_MAX_SIZE),
            stderr: stderr.slice(0, Defaults.SHELL_OUTPUT_MAX_SIZE),
            exitCode,
          })
        })
      })
    },
  }
}
